<template>
  <div class="mechanic-debt">
    <div class="mechanic-debt__half"></div>
    <div class="mechanic-debt__half">
      <h3 class="mechanic-debt__title">
        {{ $t('common.table.duty') }}
      </h3>

      <v-text-field
        outlined
        dense
        :label="$t('common.fields.sum')"
        :value="driverDebt"
        :rules="[onlyNumbers]"
        @input="$emit('update:driver-debt', $event)"
      />

      <v-textarea
        height="150"
        dense
        no-resize
        outlined
        :disabled="!driverDebt"
        :label="$t('common.fields.comment')"
        :value="driverDebtComment"
        @input="$emit('update:driver-debt-comment', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    driverDebt: {
      type: String,
      default: '',
    },
    driverDebtComment: {
      type: String,
      default: '',
    },
  },
  methods: {
    onlyNumbers(v) {
      if (!v) return true;
      return (
        /^[0-9]{1,12}$/.test(v) || this.$t('common.fields.validation.numbers')
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.mechanic-debt {
  display: flex;
  margin-top: 30px;

  &__title {
    font-size: 18px;
    font-weight: 500;
    color: #464646;
    margin-bottom: 15px;
  }

  &__half {
    width: 50%;

    &:first-child {
      padding-right: 30px;
      border-right: 1px dashed #777;
    }

    &:last-child {
      padding-left: 30px;
    }
  }
}
</style>
